import { render, staticRenderFns } from "./ClaimIncompleteTable.vue?vue&type=template&id=7b79679a"
import script from "./ClaimIncompleteTable.vue?vue&type=script&lang=js"
export * from "./ClaimIncompleteTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports